import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AppAlert from "@/components/AppAlert.vue";
import {useStore} from "vuex";
import {computed} from "vue";
import {hideSpinner, showAlert, showSpinner} from "@/store";
import UserQuestionnaireEntity from "@/db/UserQuestionnaireEntity";
import getDb from "@/db/Database";
import {useApiClient} from "@/api";
import ConfigurationEntity from "@/db/ConfigurationEntity";


export default /*#__PURE__*/_defineComponent({
  __name: 'OfflineDataUpload',
  setup(__props) {

const store = useStore()
const api = useApiClient()

const show = computed(() => store.state.offline.promptUpload)

const onCancel = () => store.commit('offline/PROMPT_UPLOAD', false)

const onOk = async () => {
  onCancel()
  showSpinner()
  const configuration = await ConfigurationEntity.get(getDb())
  if (configuration) {
    const userQuestionnaires = await UserQuestionnaireEntity.getOfflineQuestionnaires(getDb())
    for (const questionnaire of userQuestionnaires) {
      try {
        await api.saveUserQuestionnaire(configuration.sessionId, questionnaire)
        showAlert('Der Fragebogen erfolgreich am Server gespeichert!')
      } catch (err: any) {
        console.error(err)
        showAlert(err.message)
      }
    }
  }
  hideSpinner()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppAlert, {
    show: show.value,
    title: "Offline-Daten vorhanden",
    "button-label": "DATEN ÜBERTRAGEN",
    "show-cancel": "",
    onOk: onOk,
    onCancel: onCancel
  }, {
    default: _withCtx(() => [
      _createTextVNode(" Es sind noch Daten lokal gespeichert. Bitte übertragen Sie diese vorher auf den Server! ")
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})